import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "onClick"];
import { DeleteIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const RemoveButton = _ref => {
  let {
      disabled,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, rest, {
    disabled: disabled,
    onClick: onClick,
    placement: "right",
    size: "md",
    use: "link",
    children: /*#__PURE__*/_jsx(DeleteIcon, {})
  }));
};